import createReducer from './createReducer';
import { SET_ADBLOCK } from '../actions/adblock';

const initialState = false;

const handlers = {};

handlers[SET_ADBLOCK] = (state, { detected }) => detected;

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/adblock.js